export default __webpack_public_path__ + "static/media/2180.5e5e086a.png";